import { Card, CardContent, CardSubTitle, CardTitle } from "@artists/uikit"
import { Button, Skeleton } from "@mui/material"
import type { FC } from "react"

import { DEFAULT_ENTRIES_LIMIT } from "../../../api/hooks/vote"
import { Favorite } from "../favorite"

interface Props {
	text: string
	votindActive?: boolean
}

export const Skeletons: FC<Props> = ({ text, votindActive }) => (
	<>
		{[...Array(DEFAULT_ENTRIES_LIMIT).keys()].map(id => (
			<Card key={id}>
				<Skeleton
					animation='wave'
					sx={{
						pt: "100%",
						borderRadius: "0",
						transform: "none",
						"&:empty:before": { content: "''" },
					}}
				/>

				<CardContent>
					{votindActive && (
						<Button
							disabled
							fullWidth
							variant='outlined'
							sx={{ textTransform: "none", mb: 2 }}
						>
							{text}
						</Button>
					)}

					<CardTitle width='90%'>
						<Skeleton />
					</CardTitle>

					<CardSubTitle width='40%'>
						<Skeleton />
					</CardSubTitle>
				</CardContent>

				<Favorite disabled sx={{ m: 1, mt: -1 }} />
			</Card>
		))}
	</>
)
